<template>
	<vs-popup
		:title="$t('payRewardToAuthor')"
		class="set-ticket-done"
		:active.sync="activeProp"
	>
		<div
			v-if="currentStage && currentStage.marginality_correct === false"
			class="marginality-warning bg-warning"
		>
			{{ $t("marginalityWarning") }}
		</div>

		{{ $t("recommendedPaymentSum") }}: {{ recommendedPrice }}
		<!-- <vs-input
			:label="$t('authorsReward')"
			v-model="reward"
			class="mt-3"
		/> -->

		<vs-checkbox v-model="notNotifyClientState" class="mt-2 mx-0">
			{{ $t("doNotNotifyClient") }}
		</vs-checkbox>

		<div class="set-ticket-done__controls">
			<vs-button :disabled="loading" color="success" @click="confirm">
				{{ $t("pay") }}
			</vs-button>

			<vs-custom-button
				:disabled="loading"
				color="#9a9a9a"
				type="flat"
				@click="close"
			>
				{{ $t("doCancel") }}
			</vs-custom-button>
		</div>
	</vs-popup>
</template>

<script>
export default {
	name: "SetStageDonePopup",
	props: {
		active: { default: false, type: Boolean },
		notNotifyClient: { default: false, type: Boolean },
		loading: { default: false, type: Boolean },
		recommendedPrice: { default: 0 },
		currentStage: { default: null }
	},
	data() {
		return {
			reward: 0
		};
	},
	// watch: {
	// 	activeProp(newValue) {
	// 		if(newValue === false) {
	// 			this.reward = 0;
	// 		}
	// 	}
	// },
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		},

		notNotifyClientState: {
			get() {
				return this.notNotifyClient;
			},
			set(val) {
				this.$emit("update:notNotifyClient", val);
			}
		}
	},
	methods: {
		confirm() {
			if (!this.recommendedPrice) return;

			this.$emit("confirm", this.recommendedPrice);
		},

		close() {
			this.activeProp = false;
		}
	}
};
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.set-ticket-done {
	&__controls {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.vs-popup {
		max-width: 450px !important;
		width: 100% !important;
		padding: 0;

		&--content {
			width: 100%;
			height: 100%;
		}

		&--close,
		&--title h3 {
			color: $success;
		}

		&--button {
			display: flex;
			justify-content: flex-end;
			padding-top: 15px;
		}
	}

	.vs-input {
		width: 100%;
	}

	.vs-input--label {
		transition: color 0.3s ease;
	}

	.vs-input-primary.isFocus .vs-input--label {
		color: $success;
	}

	.vs-input-primary .vs-input--input:focus {
		border-color: $success !important;
	}

	.marginality-warning {
		border-radius: 4px;
		text-align: center;
		padding: 5px 0;
		margin-bottom: 15px;
	}
}
</style>
